import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  ${({ theme, checked }) => css`
    width: ${p => p.small ? '21px' : '40px'};
    height: ${p => p.small ? '12px' : '23px'};
    border-radius: 31px;

    padding-left: ${p => p.small ? '2px' : '3px'};
    padding-right: ${p => p.small ? '2px' : '3px'};
    background-color: ${checked ? theme?.colour?.primary : '#E3E3E3'};

    display: flex;
    align-items: center;
    justify-content: ${checked ? 'end' : 'start'};

    cursor: pointer;
  `}
`;